<template>
  <div class="wrap">
    <!-- 日历卡片 -->
    <div class="calendar-card">
      <!-- 自定义头部 -->
      <div class="calendar-header">
        <div class="arrow-btn" :class="{ disabled: !canGoPrev }" @click="prevMonth">
          <img src="https://hzwimspic-1251601690.image.myqcloud.com/c1b42c89-d7f4-456b-9994-7d4c1e8739d8_size_128x128"
            alt="">
        </div>
        <div class="month-title">{{ currentMonthTitle }}</div>
        <div class="arrow-btn" :class="{ disabled: !canGoNext }" @click="nextMonth">
          <img src="https://hzwimspic-1251601690.image.myqcloud.com/d2b015a0-89b9-492f-ae5c-deae08bb3e01_size_128x128"
            alt="">
        </div>
      </div>

      <!-- 星期标题 -->
      <div class="weekdays">
        <span v-for="day in weekDays" :key="day">{{ day }}</span>
      </div>

      <!-- 日历主体 -->
      <div class="calendar-body">
        <div v-for="(week, weekIndex) in calendarDays" :key="weekIndex" class="calendar-week">
          <div v-for="day in week" :key="day.date" class="calendar-day" :class="{
            'other-month': !day.isCurrentMonth,
            'selected': day.isSelected,
            'today': day.isToday,
            'disabled': day.isFuture,
            'out-of-range': day.isOutOfRange
          }" @click="selectDay(day)">
            <span class="day-number" v-if="!day.isToday">{{ day.day }}</span>
            <span class="today-badge" v-else>今</span>
            <span v-if="day.status === 'filled' && !day.isFuture" class="status-icon filled"><img
                src="https://hzwimspic-1251601690.image.myqcloud.com/788717ae-b502-4566-b85d-3bab94012cf5_size_48x48"
                alt=""></span>
            <span v-else-if="day.status === 'unfilled' && !day.isToday && !day.isFuture"
              class="status-dot unfilled"></span>
          </div>
        </div>
      </div>

      <!-- 状态说明 -->
      <div class="status-legend">
        <span class="legend-item"><i class="dot filled"></i> 已填写</span>
        <span class="legend-item"><i class="dot unfilled"></i> 未填写</span>
        <span class="legend-item"><i class="dot out"></i> 不在订单日期范围内</span>
      </div>
    </div>

    <!-- 标题时刻卡片 -->
    <div v-if="!fromUser && filledDates.includes(selectedDate.format('YYYY-MM-DD'))" class="title-card">
      <img class="baby-avatar" :src="logInfo.pics" alt="">
      <!-- <div class="title-info">
        <span class="title-label">标题时刻：</span>
        <span class="title-value">首次微笑</span>
      </div> -->
      <img class="log-edit" @click="toAddLog"
        src="https://hzwimspic-1251601690.image.myqcloud.com/52e9f16b-e0c1-4e49-9798-3d2272708ba0_size_220x109"
        alt="" />
    </div>

    <!-- 上传按钮 - 固定在底部 -->
    <div v-if="!fromUser && !filledDates.includes(selectedDate.format('YYYY-MM-DD'))" class="upload-btn-wrapper"
      @click="toAddLog">
      <div class="upload-btn">上传</div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { queryMemberLogDetail, queryOrderData, queryYuesaoLogDetail } from '../service'

export default {
  data() {
    return {
      fromUser: false,
      orderId: '',
      currentDate: dayjs(),
      logInfo: {},
      selectedDate: null,
      weekDays: ['日', '一', '二', '三', '四', '五', '六'],
      filledDates: [],
      orderStartDate: '',
      orderEndDate: ''
    }
  },
  components: {
  },
  computed: {
    currentMonthTitle() {
      return this.currentDate.format('YYYY年MM月')
    },
    canGoPrev() {
      const prevMonth = this.currentDate.subtract(1, 'month')
      const prevMonthEnd = prevMonth.endOf('month').format('YYYY-MM-DD')
      return prevMonthEnd >= this.orderStartDate
    },
    canGoNext() {
      const nextMonth = this.currentDate.add(1, 'month')
      const nextMonthStart = nextMonth.startOf('month').format('YYYY-MM-DD')
      return nextMonthStart <= this.orderEndDate
    },
    calendarDays() {
      const year = this.currentDate.year()
      const month = this.currentDate.month()
      const firstDay = dayjs(new Date(year, month, 1))
      const lastDay = firstDay.endOf('month')
      const startWeekday = firstDay.day()
      const daysInMonth = lastDay.date()

      const days = []
      let week = []

      // 填充上月日期
      const prevMonthLastDay = firstDay.subtract(1, 'day')
      for (let i = startWeekday - 1; i >= 0; i--) {
        const date = prevMonthLastDay.subtract(i, 'day')
        week.push(this.createDayObject(date, false))
      }

      // 当月日期
      for (let day = 1; day <= daysInMonth; day++) {
        const date = dayjs(new Date(year, month, day))
        week.push(this.createDayObject(date, true))

        if (week.length === 7) {
          days.push(week)
          week = []
        }
      }

      // 填充下月日期
      if (week.length > 0) {
        const remainingDays = 7 - week.length
        for (let i = 1; i <= remainingDays; i++) {
          const date = lastDay.add(i, 'day')
          week.push(this.createDayObject(date, false))
        }
        days.push(week)
      }

      return days
    }
  },
  created() {
    this.$$loading(false)
    this.selectedDate = dayjs()

    this.$$title('电子日志')
    const { orderId = '', fromuser = '0' } = this.$route.query
    this.orderId = orderId
    this.fromUser = fromuser === '1'
  },
  async mounted() {
    this.$$loading(true)
    if (this.fromUser) {
      const logDate = dayjs().format('YYYY-MM-DD');
      queryMemberLogDetail({ logDate: logDate }).then((res) => {
        this.$$loading(false)
        this.logInfo = res || {}
        this.orderStartDate = res.confirmHouseholdTime || dayjs().format('YYYY-MM-DD')
        this.orderEndDate = res.endDate || dayjs().format('YYYY-MM-DD')
        this.filledDates = res.completeDays || []
      }).catch((err) => {
        this.logInfo = {}
        this.orderStartDate = dayjs().format('YYYY-MM-DD')
        this.orderEndDate = dayjs().format('YYYY-MM-DD')
        this.filledDates = []
        this.$$loading(false)
        this.$$toast(err)
      })

    } else {

      queryOrderData({ orderId: this.orderId }).then((res) => {
        this.$$loading(false)
        this.orderStartDate = res.confirmHouseholdTime || dayjs().format('YYYY-MM-DD')
        this.orderEndDate = res.endDate || dayjs().format('YYYY-MM-DD')
        this.filledDates = res.completeDays || []
      }).catch((err) => {
        this.orderStartDate = dayjs().format('YYYY-MM-DD')
        this.orderEndDate = dayjs().format('YYYY-MM-DD')
        this.filledDates = []
        this.$$loading(false)
        this.$$toast(err)
      })
      this.queryYuesaoLog()
    }
  },
  methods: {
    queryYuesaoLog() {
      this.$$loading(true)
      const logDate = this.selectedDate.format('YYYY-MM-DD');
      queryYuesaoLogDetail({ orderId: this.orderId, logDate: logDate }).then((res) => {
        this.$$loading(false)
        this.logInfo = res || {}
      }).catch((err) => {
        this.logInfo = {}
        this.$$loading(false)
        this.$$toast(err)
      })
    },
    createDayObject(date, isCurrentMonth) {
      const dateStr = date.format('YYYY-MM-DD')
      const today = dayjs().format('YYYY-MM-DD')

      const isFuture = dateStr > today
      const isOutOfRange = dateStr < this.orderStartDate || dateStr > this.orderEndDate

      let status = null
      if (isOutOfRange) {
        status = 'out'
      } else if (this.filledDates.includes(dateStr)) {
        status = 'filled'
      } else {
        // 在订单日期范围内且不在filledDates中的均为未填写
        status = 'unfilled'
      }

      return {
        date: dateStr,
        day: date.date(),
        isCurrentMonth,
        isToday: dateStr === today,
        isSelected: this.selectedDate && dateStr === this.selectedDate.format('YYYY-MM-DD'),
        status,
        isFuture,
        isOutOfRange
      }
    },
    prevMonth() {
      if (this.canGoPrev) {
        this.currentDate = this.currentDate.subtract(1, 'month')
      }
    },
    nextMonth() {
      if (this.canGoNext) {
        this.currentDate = this.currentDate.add(1, 'month')
      }
    },
    selectDay(day) {
      if (day.isCurrentMonth && !day.isFuture && !day.isOutOfRange) {
        this.selectedDate = dayjs(day.date)
        if (this.fromUser) {
          //用户端用作日期选择器
          //存入到缓存
          window.localStorage.setItem('selectedDate', this.selectedDate.format('YYYY-MM-DD'))
          this.$router.go(-1)
        } else {
          this.queryYuesaoLog()
        }
      }
    },
    toAddLog() {
      this.$router.push(`/yuesao-serve/add-log?orderId=${this.orderId}&logDate=${this.selectedDate.format('YYYY-MM-DD')}`)
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/mixin.scss';

.wrap {
  min-height: 100vh;
  background-color: #F4F4F4;
  padding: rem(24px);
  padding-bottom: rem(170px); // 为固定按钮留出空间
}

.calendar-card {
  background: #fff;
  border-radius: rem(28px);
  padding-top: rem(24px);
  padding-bottom: rem(50px);
  margin-bottom: rem(24px);
}

.calendar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: rem(24px);
}

.arrow-btn {
  width: rem(64px);
  height: rem(64px);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  img {
    width: rem(64px);
    height: rem(64px);
  }

  &.disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
}

.month-title {
  font-size: rem(36px);
  font-weight: 600;
  color: #262626;
}

.weekdays {
  display: flex;
  margin-bottom: rem(34px);

  span {
    flex: 1;
    text-align: center;
    font-size: rem(24px);
    color: #999;
  }
}

.calendar-body {
  margin-bottom: rem(24px);
}

.calendar-week {
  display: flex;
  margin-bottom: rem(16px);
}

.calendar-day {
  flex: 1;
  height: rem(90px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;

  &.other-month {
    .day-number {
      color: #D4D4D4;
    }
  }

  &.disabled {
    cursor: not-allowed;

    .day-number,
    .today-badge,
    .status-icon,
    .status-dot {
      color: #D4D4D4;
    }
  }

  &.out-of-range {
    cursor: not-allowed;

    .day-number {
      color: #D4D4D4;
    }
  }

  &.selected {

    .day-number,
    .status-icon,
    .status-dot {
      position: relative;
      z-index: 1;
    }

    &::before {
      content: '';
      position: absolute;
      width: rem(90px);
      height: rem(90px);
      border: rem(2px) solid #ff397e;
      border-radius: 50%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: transparent;
    }
  }

  &.today {
    .today-badge {
      background: #FFF2F6;
      color: #ff397e;
      width: rem(90px);
      height: rem(90px);
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: rem(28px);
      font-weight: 600;
    }
  }
}

.today-badge {
  background: #FFF2F6;
  color: #ff397e;
  width: rem(90px);
  height: rem(90px);
  border-radius: 50%;
  display: flex;
  padding-bottom: rem(16px);
  justify-content: center;
  font-size: rem(28px);
  font-weight: 600;
}

.day-number {
  font-size: rem(28px);
  font-weight: 600;
  color: #262626;
  margin-bottom: rem(4px);
}

.status-icon {
  font-size: rem(24px);
  line-height: 1;

  &.filled {
    margin-top: rem(12px);
    color: #19c45a;

    img {
      position: absolute;
      top: rem(50px);
      left: 50%;
      transform: translateX(-50%);
      width: rem(24px);
      height: rem(24px);
    }
  }
}

.status-dot {
  width: rem(12px);
  height: rem(12px);
  border-radius: 50%;

  &.unfilled {
    background: #ff397e;
  }

  &.out {
    background: #e5e5e5;
  }
}

.status-legend {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: rem(24px);
  padding-top: rem(16px);
}

.legend-item {
  display: flex;
  align-items: center;
  font-size: rem(24px);
  color: #262626;

  .dot {
    width: rem(20px);
    height: rem(20px);
    border-radius: 50%;
    margin-right: rem(11px);

    &.filled {
      background: #09B23E;
    }

    &.unfilled {
      background: #ff397e;
    }

    &.out {
      background: #E7E7E7;
    }
  }
}

.title-card {
  background: #fff;
  border-radius: rem(28px);
  padding: rem(28px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: rem(16px);
}

.baby-avatar {
  width: rem(126px);
  height: rem(126px);
  border-radius: rem(20px);
}

.title-info {
  flex: 1;
  font-size: rem(28px);

  .title-label {
    color: #666;
  }

  .title-value {
    color: #ff397e;
    font-weight: 600;
  }
}

.log-edit {
  width: rem(122px);
  height: rem(54px);
  object-fit: cover;
}

.upload-btn-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: rem(16px) rem(24px) rem(32px);
  z-index: 100;
}

.upload-btn {
  width: 100%;
  height: rem(80px);
  background: linear-gradient(90deg, #fe397e 0%, #ff074c 100%);
  border-radius: rem(40px);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: rem(32px);
  font-weight: 600;
  color: #fff;
  cursor: pointer;
}
</style>
